import React, { useEffect } from 'react'
import useGetDiagnosticSlots from '../PurchaseDiagnostic/hooks/useGetDiagnosticSlots'
import Header from '../../components/atoms/Header'
import { useLocation, useNavigate } from 'react-router-dom'
import UserSummary from '../../components/molecules/Cart/UserSummary'
import CollectionDetails from '../../components/molecules/Cart/CollectionDetails'
import CKDTestList from '../../components/molecules/Cart/CKDTestList'
import AddressInfo from '../../components/molecules/Cart/AddressInfo'
import BillSummary from '../../components/molecules/Cart/BillSummary'
import ArrowIcon from '../../components/atoms/Arrow'
import Button from '../../components/atoms/GoodFlipButton'
import { useSelector } from 'react-redux'
import MobileLayout from '../../components/MobileLayout'

const CartPage = () => {
  const location = useLocation()
  const { state } = location
  const navigate = useNavigate()

  const { createOrder, creatingOrder, confirmOrderState } =
    useGetDiagnosticSlots()

  const onPressBack = () => {
    navigate(-1)
  }
  const onPressProceed = () => {
    let payload = state.cartData
    let reference_data =
      '{"source":"PSP - CKD","conditionName":"Chronic Kidney Disease","type":"CKD Report"}'
    payload.disease_name = 'Chronic Kidney Disease'
    payload.reference_data = reference_data
    payload.disease_id_key = 'CKD'
    createOrder(payload)
  }

  const navigateTo = (step) => {
    navigate(`/purchase-diagnostic?step=${step}`)
  }

  useEffect(() => {
    if (confirmOrderState.success && !!confirmOrderState.data) {
      navigate(`/success`, {
        state: {
          order_master_id: confirmOrderState.data.order_master_id,
          cartData: {
            ...state.cartData,
            disease_name: 'Chronic Kidney Disease',
            reference_data:
              '{"source":"PSP - CKD","conditionName":"Chronic Kidney Disease","type":"CKD Report"}',
            disease_id_key: 'CKD',
          },
        },
      })
    }
  }, [confirmOrderState])

  return (
    <MobileLayout>
      <div className="bg-background-secondary">
        <Header
          showProgressBar={false}
          title="Back"
          onPressLeftIcon={onPressBack}
        />
        <div className="py-10 flex flex-col gap-10 lg:max-w-2xl lg:mx-auto">
          <UserSummary onPressEdit={() => navigateTo(0)} />
          <CollectionDetails
            onPressEdit={() => navigateTo(2)}
            cartData={state.cartData}
          />
          <CKDTestList />
          <AddressInfo onPressEdit={() => navigateTo(1)} />
          <BillSummary />
          <div className="h-28" />
        </div>
        <div
          className={`fixed max-w-lg lg:max-w-5xl xl:max-w-6xl mx-auto bottom-0 left-0 right-0 bg-[#FFFFFF] backdrop-blur-2xl w-full pb-4 pt-2`}
        >
          <Button
            title={'Proceed'}
            type={'goodflip_primary'}
            disabled={false}
            leftIcon={null}
            rightIcon={<ArrowIcon direction="right" color="#FFFFFF" />}
            onClick={onPressProceed}
            loading={creatingOrder}
          />
        </div>
      </div>
    </MobileLayout>
  )
}

export default CartPage
